import { siteKey } from "../utils/grecaptcha";

export const RECAPTCHA_VERSION = {
  V2: "V2",
  V3: "V3",
};

export const RECAPTCHA_URL = "//www.google.com/recaptcha/api.js";
export const RECAPTCHA_V2_ONLOAD_CALLBACK = "onloadCallbackForV2";

const ACTION = "save_project";

/*
 * This function asks for a reCaptcha token and returns it.
 *
 * @param {string} recaptchaVersion - V2 or V3.
 *
 * @return {Promise.<string>} Promise returning a token to be used by BE.
 *
 */
export const getCaptchaToken = (recaptchaVersion = RECAPTCHA_VERSION.V3) => {
  if (!window.grecaptcha) {
    return Promise.reject(new Error("g-recaptcha not found"));
  }

  if (recaptchaVersion === RECAPTCHA_VERSION.V3) {
    return window.grecaptcha.execute(siteKey[recaptchaVersion], { action: ACTION });
  }

  if (recaptchaVersion === RECAPTCHA_VERSION.V2) {
    return window.grecaptcha.getResponse(window.widgetRecaptchaV2);
  }

  return Promise.reject(new Error("g-recaptcha version not recognized"));
};

export const siteKeys = siteKey;
